import * as React from "react"
import { Box, Typography, useTheme } from "@mui/material"
import ListHeading from "pages/TecDoc/components/List/components/ListHeading"
import { useTranslation } from "react-i18next"
import ListTechnicalInformation from "pages/TecDoc/components/List/ListTechnicalInformation"
import { useTecDocStore } from "api/services/TecDoc"
import { observer } from "mobx-react"
import HelpOutlineIcon from "@mui/icons-material/HelpOutline"
import { isMobile, packagesPath } from "utils/Global"

const TechnicalInformation: React.FC<{
  handleLoading: (value: boolean) => void
}> = (props) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const lang = i18n.language
  const tecDocStore = useTecDocStore()
  const {
    articleList,
    eanNumber,
    fetchTechincalInformation,
    technicalInformation,
    loadingTechnicalInformation,
  } = tecDocStore
  const [listItems, setListItems] = React.useState([])
  const countryCatalogue = localStorage.getItem("countryCatalogueCode") || "de"
  const [isFetched, setIsFetched] = React.useState(false)

  React.useEffect(() => {
    if (articleList?.articleId) {
      tecDocStore
        .fetchVehicleList(countryCatalogue, lang, articleList.articleId)
        .catch((err) => {
          console.error("Error fetching vehicles", err)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleList])

  React.useEffect(() => {
    props.handleLoading(loadingTechnicalInformation)
  }, [loadingTechnicalInformation, props])

  React.useEffect(() => {
    if (!technicalInformation && !isFetched) {
      const tempEanNumber = eanNumber
        ? Object.entries(eanNumber).map((item) => {
            return {
              key: Object.keys(item[1])[0],
              subItems: [
                {
                  label: t(Object.keys(item[1])[0]),
                  content: String(item[1]?.eanNumber),
                  docType: item[1]?.docFileTypeName,
                },
              ],
            }
          })
        : null
      const eanCode = tempEanNumber
        ? tempEanNumber[0].subItems[0].content
        : localStorage.getItem("data")
      fetchTechincalInformation(eanCode)
        .then(() => setIsFetched(true))
        .catch((err) => {
          setIsFetched(true)
          console.error("Error fetching technical information", err)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eanNumber, technicalInformation, isFetched])

  React.useEffect(() => {
    if (technicalInformation) {
      const locale = (lang) => {
        switch (lang) {
          case "de":
            return "de-DE"
          case "en":
            return "en-GB"
          case "fr":
            return "fr-FR"
          case "it":
            return "it-IT"
          case "es":
            return "es-ES"
          case "pl":
            return "pl-PL"
          case "pt":
            return "pt-PT"
          case "ro":
            return "ro-RO"
          case "cs":
            return "cs-CZ"
          default:
            return "de-DE"
        }
      }
      const makeLink = (link) => {
        return `${packagesPath}${link}/${locale(lang)}/index.html`
      }
      const entriesTI = Object.entries(technicalInformation)
      const _listItems = [
        {
          label: entriesTI[4][1],
          link: makeLink(entriesTI[3][1]),
        },
      ]
      if (entriesTI[5][1] && entriesTI[6][1]) {
        _listItems.push({
          label: entriesTI[6][1],
          link: makeLink(entriesTI[5][1]),
        })
      }
      if (entriesTI[7][1] && entriesTI[8][1]) {
        _listItems.push({
          label: entriesTI[8][1],
          link: makeLink(entriesTI[7][1]),
        })
      }
      if (entriesTI[9][1] && entriesTI[10][1]) {
        _listItems.push({
          label: entriesTI[10][1],
          link: makeLink(entriesTI[9][1]),
        })
      }
      setListItems(_listItems)
    }
  }, [tecDocStore, technicalInformation, lang])

  return (
    <Box>
      <Box sx={{ paddingBlock: theme.spacing(2), color: "white" }}>
        <ListHeading
          title={t("technicalInformationTitle")}
          caret={"NONE"}
          variant={"PRIMARY"}
        />
      </Box>
      {listItems.length > 0 ? (
        <ListTechnicalInformation items={listItems} />
      ) : (
        !loadingTechnicalInformation && (
          <Box>
            <Box
              sx={{
                borderRadius: "4px",
                background: "rgba(0, 0, 0, 0.06)",
                padding: "24px",
                textAlign: "center",
                lineHeight: 1,
              }}
            >
              <HelpOutlineIcon fontSize={"large"} />
              <Typography
                variant={"body1"}
                sx={{
                  marginTop: "16px",
                  color: "#373737",
                  fontSize: isMobile ? "20px" : "24px",
                  fontWeight: "bold",
                  lineHeight: 2,
                }}
              >
                {t("technicalInformationNoDataTitle")}
              </Typography>
              <Typography
                variant={"body2"}
                sx={{ color: "#373737", fontSize: isMobile ? "14px" : "18px" }}
              >
                {t("technicalInformationNoDataText")}
              </Typography>
            </Box>
          </Box>
        )
      )}
    </Box>
  )
}
export default observer(TechnicalInformation)
